<template>
<div :style="{ backgroundColor : bgColor, height: 16 + 'px' }" />
</template>

<script>
export default {
    name: "SectionDivider",
    props: {
	bgColor: String
    }
}
</script>
